

// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-free/css/all.css";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'lightgallery/src/sass/lightgallery.scss';

import 'bootstrap';
import 'slick-carousel';

import basicNavigation from './header/header-basic';
import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import Instafeed from 'instafeed.js';

window.Instafeed = Instafeed;

function setCookie(cname, cvalue, exdays) {
    var expires = "expires=0";
    if(exdays !== 0){
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = "expires="+d.toUTCString();
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function showPopup() {
    var popup = getCookie("shownPopup");
    var popupBehaviour = $('#popupMessage').attr('data-close-type');
    if (popup === '' && popupBehaviour === 'PerSession') {
        $('#popupMessage').addClass('show-me');
        $('#popupMessage').removeClass('d-none');
        LayoutPopUp();
    }
    if(popupBehaviour === 'Always') {
        $('#popupMessage').addClass('show-me');
        $('#popupMessage').removeClass('d-none');
        LayoutPopUp();
    }
}

function LayoutPopUp(){
    if($('#popupMessage').length > 0){
        var popup = getCookie("shownPopup");
        var popupHeight = 0;
        var popupBehaviour = $('#popupMessage').attr('data-close-type');
        popupHeight = $('#popupMessage').outerHeight();
        if($('#popupMessage').hasClass('show-me')){
            $('nav.navbar').css('transform', 'translateY('+popupHeight+'px)');
            $('nav.navbar').css('transition', '0.1s');
            if(!$('body').hasClass('HomePage')) {
                $('main.main-content').css('transform', 'translateY('+popupHeight+'px)');
                $('main.main-content').css('transition', '0.1s');
            }
        }
        if($('#ClosePopUp').length > 0){
            $('#ClosePopUp').on('click',function () {
                closePopUpAction();
            });
        }


        if(popupBehaviour === 'PerSession' && popup === ''){
            setCookie('shownPopup',true,0);
            return false;
        }

    }
}


function closePopUpAction(){
    $('#popupMessage').removeClass('show-me');
    $('#popupMessage').addClass('d-none');
    var headerHeight = $('header.header nav').outerHeight();
    if(!$('body').hasClass('HomePage')) {
        $('nav.navbar').css('margin-top', '0px');
        $('nav.navbar').css('transform', 'translateY(0px)');
        $('nav.navbar').css('transition', '0.3s');
        $('main.main-content').css('margin-top', headerHeight + 'px');
        $('main.main-content').css('transform', 'translateY(0px)');
    } else {
        $('nav.navbar').css('margin-top', '0px');
        $('nav.navbar').css('transform', 'translateY(0px)');
        $('nav.navbar').css('transition', '0.3s');
    }
}


$(window).on('load', function () {
    LayoutTiles();

});

$(window).resize(function () {
    $(".event-item").each(function(){
        var event_item_summary = $(this).find(".event-summary");
        var attr = event_item_summary.attr('style');
        if (typeof attr !== typeof undefined && attr !== false) {
            event_item_summary.removeAttr('style');
        }
    });
    $("#event-calendar-events").html($("#event-calendar-events").html());
    LayoutTiles();
    LayoutPopUp();
});

function LayoutTiles(){
    var maxHeight = 0;

    $(".event-item").each(function(){
        if ($(this).find(".event-summary").height() > maxHeight) {
            maxHeight = $(this).find(".event-summary").outerHeight();
        }
    });
    maxHeight = maxHeight + 20;
    $(".event-item").each(function(){
        $(this).find(".event-summary").css('height', maxHeight + 'px');
    });
}




$(document).ready(function(){
    if ($('#event-calendar-events .row').find('.event-item').length > 0) {
        $('.event-calendar-controls a.events-btn').addClass('d-none');
    } else {
        $('.event-calendar-controls a.events-btn').removeClass('d-none');
    }

    if($('.Calendar').length > 0){
        $('.dtstart').html(function(index, html){
            return html.replace(/-/g, '- <br>');
        });
    }

    showPopup();
});

$(function () {

    basicNavigation();

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');


    if ($('.carousel.full-height .slick').length > 0) {
        $('.carousel.full-height .slick').slick({
            autoplay: true,
            autoplaySpeed: 4000,
            fade: true,
            arrows: false
        });
    }

    if ($('.lightgallery').length > 0) {
        $('.lightgallery').lightGallery({
            selector: '.lightgallery-item',
            thumbnail: true
        });
    }

    if ($('.elemental-sponsors .slick').length > 0) {
        $('.elemental-sponsors .slick').slick({
            slidesToShow: 5,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        arrows: false,
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        arrows: false,
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        slidesToShow: 2
                    }
                }
            ]
        });
    }

    if ($('.event-slider .slick').length > 0) {
        if($('.ExhibitionPage')){
            $('.event-slider .slick').on('init', function() {
                $('.slick-prev').on('click',function() {
                    $('.event-slider .slick').slick('slickPause');
                });
                $('.slick-next').on('click',function() {
                    $('.event-slider .slick').slick('slickPause');
                });
            }).slick({
                slidesToShow: 1,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 3000,
                fade: true,
                prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fas fa-chevron-left' aria-hidden='true'></i></button>",
                nextArrow:"<button type='button' class='slick-next pull-right'><i class='fas fa-angle-right' aria-hidden='true'></i></button>"
            });
        } else {
            $('.event-slider .slick').slick({
                slidesToShow: 1,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3000,
                fade: true
            });
        }
    }

    if ($('.single-event-slider .slick').length > 0) {
        $('.single-event-slider .slick').slick({
            slidesToShow: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            fade: true
        });
    }

    $('.hail-carousel').each(function(index, element){
        //Build carousel options (from the Hail carousel DataObject)
        const slickOptions = {
            lazyLoad: 'ondemand',
            dots: ($(element).data('showdots') === "Yes"),
            slidesToShow: $(element).data('lg-toshow'),
            slidesToScroll: $(element).data('lg-toscroll'),
            responsive: [
                {
                    breakpoint: $(element).data('md-break'),
                    settings: {
                        slidesToShow: $(element).data('md-toshow'),
                        slidesToScroll: $(element).data('md-toscroll')
                    }
                },
                {
                    breakpoint: $(element).data('sm-break'),
                    settings: {
                        slidesToShow: $(element).data('sm-toshow'),
                        slidesToScroll: $(element).data('sm-toscroll'),
                        arrows: false
                    }
                }
            ]
        };

        $(element).slick(slickOptions);
    });

});

if (detectIE()) {
    $('body').addClass('ie');
}
function detectIE() {
    const ua = window.navigator.userAgent;

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    // other browser
    return false;
}
